import React from 'react';
import Table from "../Table/Table";
import BoxHeader from "./BoxHeader";
import TableService from "../../services/TableService";
import PaginationComponent from "../Table/PaginationComponent";
import Loading from "../Loading/Loading";
import Objects from "../../utils/Objects";

class BoxTableWithPagination extends React.Component {

  tableService = new TableService();

  constructor(props) {
    super(props);
    this.state = {loading: true, url: props.url};
    this.getDate = this.getDate.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.url !== nextProps.url) {
      this.setState({url: nextProps.url});
      this.getDate(nextProps.url);
    }
  }

  getDate(url, page = 0, size = 10) {
    if (Objects.isEmptyOrBlank(url)) {
      return;
    }
    this.setState({loading: true});
    let urlToRequest = url + (url.indexOf('?') > 0 ? '&' : '?') + `page=${page}&size=${size}`;
    this.tableService.getData(urlToRequest).then(
        (data) => this.setState({
          items: data.content,
          currentPage: data.number,
          totalPages: data.totalPages,
          loading: false
        }, () => this.props.onDataLoad && this.props.onDataLoad(data))
    ).catch(
        () => this.setState({message: 'Falha ao carregar', loading: false})
    )
  }

  componentDidMount() {
    const {url} = this.state;
    this.setState({loading: true});
    this.getDate(url);
  }

  render() {
    const {title, notResponsiveTable, columns, type, boxHeader, bodyRender} = this.props;
    const {items = [], totalPages = 0, currentPage = 0, loading, url} = this.state;
    let header = boxHeader ? boxHeader : null;

    if (loading) {
      return <Loading/>;
    }

    if (header === null) {
      header = title ? <BoxHeader title={title}/> : '';
    }

    const body = items.map((item) => bodyRender(item));

    return (
        <div className={(type ? type : '') + " box"}>
          {header}
          <div className={(notResponsiveTable ? ''
              : 'table-responsive no-padding') + " box-body"}>
            <Table>
              <thead>
              {columns}
              </thead>
              <tbody>
              {body}
              </tbody>
            </Table>
          </div>
          <div className="box-footer clearfix">
            <PaginationComponent totalPages={totalPages} currentPage={currentPage} onChange={(e) => {
              this.getDate(url, e.page, e.size);
            }}/>
          </div>
        </div>
    );
  };

// BoxTableWithPagination.propTypes = {
//   title: PropTypes.string,
//   responsiveTable: PropTypes.bool,
//   type: PropTypes.string,
//   collection: PropTypes.object,
//   ippReactVar: PropTypes.object,
//   pageReactVar: PropTypes.object,
//   boxHeader: PropTypes.node
// };
}

export default BoxTableWithPagination;





// WEBPACK FOOTER //
// ./src/component/Box/BoxTableWithPagination.js